import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import { RequestFeedbackBody } from 'screens/performanceReview/components/ContinuousFeedback/Drawers/RequestFeedback/RequestFeedbackBody';
import { useSaveRequestFeedback } from 'screens/performanceReview/components/ContinuousFeedback/Drawers/RequestFeedback/dataHooks';
import { useSaveButtonDisabled } from 'screens/performanceReview/components/ContinuousFeedback/Drawers/RequestFeedback/hooks';
import { Footer } from 'screens/performanceReview/components/ContinuousFeedback/Drawers/common/Footer';
import {
  setClearRequestedFeedbackData,
  useRequestedFeedbackData,
} from 'screens/performanceReview/components/ContinuousFeedback/Drawers/slice/feedbackSlice';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';

import { Divider } from 'uiToolkitV1/Divider';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { setPrimaryScreen, setSecondaryPanelOpen, setSecondaryScreen } from '../competencyDrawerSlice';
import { PrimaryDrawerScreens, SecondaryDrawerScreens } from '../types/slice';

export const RequestFeedbackPanel = () => {
  const dispatch = useDispatch();

  const prefilledReceiverId = useSelector(selectLoggedInEmployeeId);

  const closeSecondaryPanel = () => {
    dispatch(setSecondaryPanelOpen(false));
  };

  const onClose = () => {
    closeSecondaryPanel();
    setTimeout(() => {
      dispatch(setClearRequestedFeedbackData());
    }, 500);
  };

  const { onSave, isSaving } = useSaveRequestFeedback({ source: 'develop_panel', onClose });

  const { receiverEmployeeId, providerEmployees, questionText } = useRequestedFeedbackData();

  const saveButtonDisabled = useSaveButtonDisabled({
    receiverEmployeeId,
    providerEmployees: providerEmployees.length,
    isSaving,
    questionText,
  });

  const openGoalSelection = () => {
    dispatch(setPrimaryScreen(PrimaryDrawerScreens.REQUEST_FEEDBACK));
    dispatch(setSecondaryScreen(SecondaryDrawerScreens.GOAL_SELECTION));
  };

  return (
    <Flex flexDir="column" borderRadius="8px" bgColor="#FFFFFF" flex={1}>
      <Box p="12px" pb="8px !important">
        <TextBodyMedium bold>Request Feedback</TextBodyMedium>
      </Box>
      <Divider borderColor="#CFD7DF" my={3} />
      <Box p={2} mb="auto">
        <RequestFeedbackBody prefilledReceiverId={prefilledReceiverId} openSecondaryPanel={openGoalSelection} />
      </Box>
      <Footer
        onClose={onClose}
        onSave={onSave}
        saveButtonDisabled={saveButtonDisabled.isDisabled}
        saveButtonDisabledReason={saveButtonDisabled.reason}
      />
    </Flex>
  );
};
